import Services from "../../api/Services";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../../components/LocalizedLink/LocalizedLink";

const ServiceSidebar = () => {
  const { t } = useTranslation("services");
  return (
    <div className="col-lg-4 col-md-8">
      <div className="wpo-single-sidebar">
        <div className="wpo-service-widget widget">
          <h2>{t("listTitle")}</h2>
          <ul>
            {Services.slice(0, 6).map((service, Sitem) => (
              <li className="text-center" key={Sitem}>
                <LocalizedLink to={`/service-single/${service.slug}`}>
                  {t(`${service.slug}.title`)}
                </LocalizedLink>
              </li>
            ))}
          </ul>
        </div>
        {/* <div className="wpo-newsletter-widget widget">
                    <h2>Newsletter</h2>
                    <p>Join 20,000 Sabscribers!</p>
                    <form className="form" onSubmit={SubmitHandler}>
                        <input type="text" placeholder="Email Address"/>
                            <button type="submit">Sign Up</button>
                    </form>
                    <span>By signing up you agree to our <Link to="/contact">Privecy Policy</Link></span>
                </div>
                <div className="wpo-instagram-widget widget">
                    <h2>Instagram Shot</h2>
                    <ul>
                        <li><img src={ins1} alt="instragram" /></li>
                        <li><img src={ins2} alt="instragram" /></li>
                        <li><img src={ins3} alt="instragram" /></li>
                        <li><img src={ins4} alt="instragram" /></li>
                        <li><img src={ins5} alt="instragram" /></li>
                        <li><img src={ins6} alt="instragram" /></li>
                    </ul>
                </div> */}
      </div>
    </div>
  );
};

export default ServiceSidebar;
